import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GenericResponse } from 'app/models2/commos/generic-response';
import { ModalMaintenanceHistory } from 'app/models2/maintenance/modal-maintenance-history';
import { RentalOrder } from 'app/models2/rental/rental-order';
import { RentalRegister } from 'app/models2/rental/rental-register';
import { UtilsServiceService } from 'app/services/utils-service.service';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import { HttpService, MessageService } from 'brainloper-ui';

@Component({
  selector: 'app-modal-rental-order',
  templateUrl: './modal-rental-order.component.html',
  styleUrls: ['./modal-rental-order.component.scss']
})
export class ModalRentalOrderComponent implements OnInit {

  public formPutRO: FormGroup
  public movil

  constructor(
    public dialogRef: MatDialogRef<ModalRentalOrderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ModalMaintenanceHistory<RentalOrder>,
    private message: MessageService,
    private http: HttpService,
    private formBuilder: FormBuilder,
    private utils: UtilsServiceService
  ) { 
    this.formPutRO = this.formBuilder.group(
      {
        rentalId: this.data.$event.id,
        stateId: this.data.$event.stateId,
        date: "",
        time: "",
        comment: ""
      }
    )
  }

  ngOnInit(): void {
    this.movil = screen.width > 600 ? false : true
  }

  async updateRetalOrder(form: RentalRegister) {

    this.message.openLoading('Cargando', 'Creando Registro');

    form.date =  this.utils.formatDateTime(form.date, form.time)

    const res: GenericResponse = await this.http.postDataBody(EndpointDictionary.RentalOrder.CRUD_RENTAL_ORDER_REGISTER, form);

    if (res) {
      this.message.closeLoading();
      this.dialogRef.close();
      this.message.SuccessToast('Orden de Alquiler actualizada correctamente');
    } else {
      this.message.closeLoading();
    }

  }

  errorMessage() {
    this.message.Error('Error', 'complete los campos')
  }

}
